(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dream-high-returns-exchanges"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('[data-dh-returns]');
  if(!root||root.dataset.bound==='true')return;
  root.dataset.bound='true';
  var form=document.getElementById('DreamHighReturnsRequest');
  if(!form)return;
  var reason=document.getElementById('DhReturnsReason');
  var evidence=document.getElementById('DhReturnsEvidence');
  var message=document.getElementById('DhReturnsMessage');
  var count=document.getElementById('DhReturnsCount');
  var reference=document.getElementById('DhReturnsReference');
  var key='dhReturnsReference';
  window.dataLayer=window.dataLayer||[];
  function track(name,params){window.dataLayer.push(Object.assign({event:name,page_handle:'returns-and-exchanges'},params||{}));}
  function syncEvidence(){
    if(!reason||!evidence)return;
    var copy='';
    if(reason.value==='Damaged in transit'){
      copy='For transit or package damage, retain the original packaging and provide a continuous unboxing video showing the unopened parcel, the condition of the outer packaging, the parcel being opened and the condition of the product when it is first removed. This video is required for Dream High to assess the claim.';
    }else if(reason.value==='Product appears defective'){
      copy='Please keep clear photographs showing the product and the specific concern handy. A Dream High Client Advisor may request them during review.';
    }else if(reason.value==='Product different from ordered or advertised'){
      copy='Please keep clear photographs of the product received, its packaging and any identifying labels handy so Dream High can compare the delivery with the order and product representation.';
    }
    evidence.textContent=copy;
    evidence.hidden=!copy;
  }
  function updateCount(){if(message&&count)count.textContent=message.value.length+' / 300';}
  function makeReference(){return 'RET-'+Date.now().toString(36).toUpperCase();}
  if(reason){reason.addEventListener('change',syncEvidence);syncEvidence();}
  if(message){message.addEventListener('input',updateCount);updateCount();}
  form.addEventListener('focusin',function(){if(!form.dataset.started){form.dataset.started='true';track('returns_form_start');}});
  form.addEventListener('submit',function(){
    if(reference&&!reference.value)reference.value=makeReference();
    try{if(reference)sessionStorage.setItem(key,reference.value);}catch(e){}
    track('returns_form_submit',{request_type:(document.getElementById('DhReturnsRequestType')||{}).value||'',reason:reason?reason.value:''});
  });
  root.querySelectorAll('[data-dh-return-prefill]').forEach(function(link){
    link.addEventListener('click',function(){
      var value=link.getAttribute('data-dh-return-prefill')||'';
      if(reason){reason.value=value;syncEvidence();}
      window.setTimeout(function(){form.scrollIntoView({behavior:'smooth',block:'start'});if(reason)reason.focus({preventScroll:true});},20);
      track('returns_priority_action',{reason:value});
    });
  });
  var success=document.getElementById('DhReturnsSuccessReference');
  if(success){
    var saved='';
    try{saved=sessionStorage.getItem(key)||'';}catch(e){}
    if(saved)success.textContent=saved;
    track('returns_form_success',{reference:saved||'unavailable'});
    try{sessionStorage.removeItem(key);}catch(e){}
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-before-social-links-20260910"]) return;
  try {
    
  const footerMedia = window.matchMedia('(max-width: 599px)');
  const syncFooterColumns = () => {
    document.querySelectorAll('.dh-footer__column').forEach((column) => {
      if (footerMedia.matches) {
        column.removeAttribute('open');
      } else {
        column.setAttribute('open', '');
      }
    });
  };
  syncFooterColumns();
  footerMedia.addEventListener('change', syncFooterColumns);

  document.querySelectorAll('.dh-footer').forEach((footer) => {
    const brand = footer.querySelector('.dh-footer__brand');
    const logo = footer.querySelector('.dh-footer__brand-logo');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!brand || !logo || reduceMotion.matches) return;

    const prepareMotion = () => {
      footer.classList.add('dh-footer--motion-ready');

      const brandObserver = new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;

          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              brand.classList.add('is-visible');
            });
          });

          observer.disconnect();
        },
        { threshold: 0.25 }
      );

      brandObserver.observe(brand);
    };

    if (logo.complete && logo.naturalWidth > 0) {
      prepareMotion();
    } else {
      logo.addEventListener('load', prepareMotion, { once: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const footerMedia = window.matchMedia('(max-width: 599px)');
  const syncFooterColumns = () => {
    document.querySelectorAll('.dh-footer__column').forEach((column) => {
      if (footerMedia.matches) {
        column.removeAttribute('open');
      } else {
        column.setAttribute('open', '');
      }
    });
  };
  syncFooterColumns();
  footerMedia.addEventListener('change', syncFooterColumns);

  document.querySelectorAll('.dh-footer').forEach((footer) => {
    const brand = footer.querySelector('.dh-footer__brand');
    const logo = footer.querySelector('.dh-footer__brand-logo');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!brand || !logo || reduceMotion.matches) return;

    const prepareMotion = () => {
      footer.classList.add('dh-footer--motion-ready');

      const brandObserver = new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;

          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              brand.classList.add('is-visible');
            });
          });

          observer.disconnect();
        },
        { threshold: 0.25 }
      );

      brandObserver.observe(brand);
    };

    if (logo.complete && logo.naturalWidth > 0) {
      prepareMotion();
    } else {
      logo.addEventListener('load', prepareMotion, { once: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["founders-privilege-hero-v2"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    if(!document.body.classList.contains('template-suffix-founders-privilege'))return;
    var hero=document.querySelector('[data-fp-hero]');
    var root=document.querySelector('[data-founders-privilege]');
    var header=document.querySelector('.header-section');
    var links=document.querySelectorAll('a[href^="#fp-"]');
    if(!hero||!root||!links.length)return;
    var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    var resizeFrame=0;

    function heroDocumentTop(){
      return Math.max(0,Math.round(hero.getBoundingClientRect().top+window.pageYOffset));
    }

    function syncHeroHeight(){
      if(window.innerWidth<900){hero.style.removeProperty('--fp-hero-height');return;}
      var available=Math.floor(window.innerHeight-heroDocumentTop());
      hero.style.setProperty('--fp-hero-height',Math.max(360,available)+'px');
    }

    function headerOffset(){
      if(!header)return 16;
      var style=window.getComputedStyle(header);
      var participates=style.position==='sticky'||style.position==='fixed';
      return (participates?Math.ceil(header.getBoundingClientRect().height):0)+16;
    }

    function syncOffset(){
      resizeFrame=0;
      root.style.setProperty('--fp-header-offset',headerOffset()+'px');
      syncHeroHeight();
    }

    function requestOffsetSync(){
      if(resizeFrame)return;
      resizeFrame=window.requestAnimationFrame(syncOffset);
    }

    function move(target,updateHash){
      if(!target)return;
      var top=target.getBoundingClientRect().top+window.pageYOffset-headerOffset();
      window.scrollTo({top:Math.max(0,top),behavior:reduced.matches?'auto':'smooth'});
      if(updateHash&&history.replaceState)history.replaceState(null,'','#'+target.id);
    }

    links.forEach(function(link){
      link.addEventListener('click',function(event){
        var selector=link.getAttribute('href');
        var target=selector&&document.querySelector(selector);
        if(!target)return;
        event.preventDefault();
        move(target,true);
      });
    });

    syncOffset();
    window.addEventListener('load',requestOffsetSync,{once:true});
    window.addEventListener('resize',requestOffsetSync,{passive:true});
    window.addEventListener('orientationchange',requestOffsetSync,{passive:true});
    if('ResizeObserver' in window){
      var ro=new ResizeObserver(requestOffsetSync);
      if(header)ro.observe(header);
      if(hero.previousElementSibling)ro.observe(hero.previousElementSibling);
    }

    if(window.location.hash&&window.location.hash.indexOf('#fp-')===0){
      var initial=document.querySelector(window.location.hash);
      if(initial)setTimeout(function(){syncOffset();move(initial,false)},60);
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

  } catch(e) { console.error(e); }
})();
})();
